import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeContextProvider } from "./ThemeContext";
import ExpandableList from "./ExpandableList";
import ClaimForm from "./ClaimForm";
import ClaimDetails from "./ClaimDetails";
import UserCreationForm from "./component/UserCreationForm";
import Profile from "./component/Profile";
import ChangePassword from "./component/ChangePassword";
import AcceptanceForm from "./component/AcceptanceForm";
import TabulationForm from "./TabulationForm";
import SignIn from "./Login/SignIn";
import Reports from "./Analytics/Reports";
import RequireAuth from "./component/RequireAuth";
import Unauthenticated from "./component/Unauthenticated";

function App() {
	return (
		<ThemeContextProvider>
			<Router>
				<div className="App">
					<Routes>
						<Route 
							path="/" 
							element={<SignIn />} 
						/>
						<Route 
							path="/home" 
							element={<RequireAuth><ExpandableList /></RequireAuth>} 
						/>
						<Route 
							path="/claim/:from" 
							element={<RequireAuth><ClaimForm /></RequireAuth>} 
						/>
						<Route
							path="/details/:token"
							element={<ClaimDetails />}
						/>
						<Route
							path="/createUser"
							element={<RequireAuth><UserCreationForm /></RequireAuth>}
						/>
						<Route 
							path="/profile" 
							element={<RequireAuth><Profile /></RequireAuth>} 
						/>
						<Route
							path="/changePassword"
							element={<RequireAuth><ChangePassword /></RequireAuth>}
						/>
						<Route 
							path="/data-reports" 
							element={<RequireAuth><Reports /></RequireAuth>} 
						/>
						<Route
							path="/acceptance/:token"
							element={<AcceptanceForm />}
						/>
						<Route
							path="/lossform/:assignmentName"
							element={<RequireAuth><TabulationForm /></RequireAuth>}
						/>
						<Route path="*" element={<Unauthenticated />} />
					</Routes>
				</div>
			</Router>
		</ThemeContextProvider>
	);
}

export default App;
